var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageBubble = function SvgMessageBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M17.5 9.583a7 7 0 0 1-.75 3.167 7.08 7.08 0 0 1-6.333 3.917 7 7 0 0 1-3.167-.75l-3.169 1.056a.833.833 0 0 1-1.054-1.054l1.056-3.169a7 7 0 0 1-.75-3.167A7.08 7.08 0 0 1 7.25 3.25a7 7 0 0 1 3.167-.75h.416A7.067 7.067 0 0 1 17.5 9.167z"
  })));
};
export default SvgMessageBubble;